import i18n from "i18next";
import {initReactI18next} from "react-i18next";

const resources = {
    ru: {
        translation: {
            "MainTitleTitle": "Главная",
            "MainTitleTip": "Начните с выбора в меню необходимого вам сервиса!",
            "MainTitlePolicy": "Политика конфиденциальности",
            "MainTitleAgreement": "Пользовательское соглашение",
            "MainTitleWarning": "Предупреждение о рисках",
            "PrivacyBackButton": "Назад",
            "PrivacyPolicyTitle": "Политика конфиденциальности и обработки персональных данных",
            "UserAgreementTitle": "Публичный договор-оферта",
            "RisksWarningTitle": "Возможные риски при работе на финансовых рынках",
            "MenuExit": "Выйти",
            "MenuMainTitle": "Главная",
            "MenuLogin": "Вход",
            "MenuRegistration": "Регистрация",
            "MenuSignals": "Сигналы",
            "MenuMain": "Советники",
            "MenuStrategies": "Стратегии",
            "MenuPositions": "Позиции",
            "MenuRatings": "Рейтинги",
            "MenuTesting": "Тестирование",
            "MenuUserAdministration": "Адм. польз",
            "MenuPrivacyPolicy": "Политика конфиденциальности",
            "MenuUserAgreement": "Пользовательское соглашение",
            "MenuRisksWarning": "Предупреждение о рисках",
            "MenuSimulatedTransaction": "Симулятор сделок",
            "MenuInvestingTip": "Демо торгового сигнала",
            "MenuEmailParsing": "Парсинг почтовых адресов",
            "LoginTitle": "Авторизация",
            "LoginEmail": "Email",
            "LoginEmailTip": "Пожалуйста введите ваш email",
            "LoginPassword": "Пароль",
            "LoginPasswordTip": "Пожалуйста введите ваш пароль",
            "LoginButton": "Авторизоваться",
            "RegistrationTitle": "Регистрация",
            "RegistrationEmail": "Email",
            "RegistrationEmailTip": "Пожалуйста введите ваш email",
            "RegistrationPassword": "Пароль",
            "RegistrationPasswordTip": "Пожалуйста введите ваш пароль",
            "RegistrationButton": "Зарегистрироваться",
            "SignalsTitle": "Торговые сигналы",
            "SignalsTableTitle": "Готовые инвестиционные решения",
            "SignalsActualSignals": "Актуальные сигналы",
            "SignalsSwitchTracking": "Отслеживание",
            "SignalsSwitchAllNotifications": "Все уведомления",
            "SignalsSwitchImportantNotifications": "Важные уведомления",
            "SignalsToClosePosition": "На закрытие позиции",
            "SignalsToOpenPosition": "На открытие позиции",
            "SignalsSignalRegistry": "Реестр недавних сигналов",
            "SignalsHeaderRegistryDate": "Дата",
            "SignalsHeaderRegistryTicker": "Тикер",
            "SignalsHeaderRegistryAction": "Действие",
            "SignalsHeaderRegistryVolume": "Объем",
            "SignalsHeaderRegistryPrice": "Цена",
            "SignalsHeaderRegistryTakeStop": "Tk/St",
            "SignalsSignalAction": "действие",
            "SignalsSignalVolume": "условный объем",
            "SignalsSignalVolumeDescription": "Доля от объема средств, выделенных на одну компанию",
            "SignalsSignalPrice": "цена",
            "RecommendationLabelBuy": "Купить",
            "RecommendationLabelSell": "Продать",
            "StateOfTradeLabelNeedOpenSeries": "Открыть позицию",
            "StateOfTradeLabelNeedAddEnterInSeries": "Увеличить позицию",
            "StateOfTradeLabelNeedAddExitInSeries": "Уменьшить позицию",
            "StateOfTradeLabelNeedCloseSeries": "Закрыть позицию",
            "MainTitle": "Советники",
            "MainTitleButtonOn": "Старт",
            "MainTitleButtonOff": "Стоп",
            "MainTableTitle": "Настройки",
            "MainChoosingCountry": "Выбор страны фондовой биржи",
            "MainChoosingCountryPlaceholder": "Страна биржи",
            "MainTipChoosingCountry": "Необходимо выбрать страну!",
            "MainTipWaitDownloading": "Дождитесь загрузки данных!",
            "MainTipClickStart": "Нажмите кнопку старт для запуска советника!",
            "SimulatedTransactionTitle": "Симулятор сделок",
            "CountryExchangeLabelRu": "Россия",
            "CountryExchangeLabelUS": "Америка",
            "GetDataColorIndicatorCharts": "Индикатор загрузки графиков с отставанием",
            "GetDataColorIndicatorQuotes": "Индикатор загрузки последних котировок",
            "GetDataRatingIsExpired": "Необходимо актуализировать рейтинги",
            "GetDataRatingDateOfExpFUND": "Дата экспирации фундаментального",
            "GetDataRatingDateOfExpTECH": "Дата экспирации технического",
            "GetDataRatingDateOfExpMEMB": "Дата экспирации рейтинга прогнозирующих пользователей",
            "GetDataTipWaitDownloading": "Дождитесь загрузки данных!",
            "AdvisorsColorIndicatorAnalytics": "Индикатор загрузки аналитических данных",
            "AdvisorsTableTitle": "Работа с торговыми стратегиями",
            "AdvisorsSubmittedApplicationsTitle": "Список выставленных заявок",
            "AdvisorsTradingRecommendationsTitle": "Торговые рекомендации",
            "AdvisorsSwitchTracking": "Отслеживание",
            "AdvisorsSwitchAllNotifications": "Уведомления",
            "SignalsToCustomers": "Сигналы подписчикам",
            "FreeSignal": "Сигнал бесплатный",
            "AdvisorsToClosePosition": "На закрытие позиции",
            "AdvisorsToOpenPosition": "На открытие позиции",
            "AdvisorsToIncreasePosition": "На увеличение позиции",
            "AdvisorsOrderStrategy": "Стратегия",
            "AdvisorsOrderAction": "действие",
            "AdvisorsOrderTimeframe": "таймфрейм",
            "AdvisorsOrderDiversificationGroup": "группа диверсификации",
            "AdvisorsOrderSpecificities": "особенности",
            "AdvisorsOrderVolume": "условный объем",
            "AdvisorsOrderVolumeDescription": "Доля от объема средств, выделенных на одну компанию",
            "AdvisorsOrderPrice": "цена",
            "AdvisorsOrderMakeDeal": "оформить сделку",
            "AdvisorsOrderCancelOrder": "отменить заявку",
            "AdvisorsOrderSubmitOrder": "оформить заявку",
            "AdvisorsOrderViewAnalytics": "посмотреть аналитику",
            "PopupAnalyticsTitle": "Аналитика по компании",
            "PopupAnalyticsTabNews": "Новости",
            "PopupAnalyticsTabAnalytics": "Аналитика",
            "PopupAnalyticsTabCharts": "Графики",
            "PopupAnalyticsTabLong": "Долгосрок",
            "PopupAnalyticsTabCandlesticks": "Свечи",
        }
    },
    en: {
        translation: {
            "MainTitleTitle": "Main",
            "MainTitleTip": "Start by selecting the service you need in the menu!",
            "MainTitlePolicy": "Privacy policy",
            "MainTitleAgreement": "User agreement",
            "MainTitleWarning": "Risk warning",
            "PrivacyBackButton": "Back",
            "PrivacyPolicyTitle": "Privacy and Personal Data Processing Policy",
            "UserAgreementTitle": "Public agreement-offer",
            "RisksWarningTitle": "Possible risks when working in financial markets",
            "MenuExit": "Exit",
            "MenuMainTitle": "Main",
            "MenuLogin": "Login",
            "MenuRegistration": "Registration",
            "MenuSignals": "Signals",
            "MenuMain": "Advisors",
            "MenuStrategies": "Strategies",
            "MenuPositions": "Positions",
            "MenuRatings": "Ratings",
            "MenuTesting": "Testing",
            "MenuUserAdministration": "User Admin",
            "MenuPrivacyPolicy": "Privacy policy",
            "MenuUserAgreement": "User agreement",
            "MenuRisksWarning": "Risks warning",
            "MenuSimulatedTransaction": "Transaction Simulator",
            "MenuInvestingTip": "Demo trading signal",
            "MenuEmailParsing": "Email Address parsing",
            "LoginTitle": "Authorization",
            "LoginEmail": "Email",
            "LoginEmailTip": "Please enter your email address",
            "LoginPassword": "Password",
            "LoginPasswordTip": "Please enter your password",
            "LoginButton": "Log in",
            "RegistrationTitle": "Registration",
            "RegistrationEmail": "Email",
            "RegistrationEmailTip": "Please enter your email address",
            "RegistrationPassword": "Password",
            "RegistrationPasswordTip": "Please enter your password",
            "RegistrationButton": "Register",
            "SignalsTitle": "Trading signals",
            "SignalsTableTitle": "Ready-made investment solutions",
            "SignalsActualSignals": "Current signals",
            "SignalsSwitchTracking": "Tracking",
            "SignalsSwitchAllNotifications": "All notifications",
            "SignalsSwitchImportantNotifications": "Important notifications",
            "SignalsToClosePosition": "To close a position",
            "SignalsToOpenPosition": "To open a position",
            "SignalsSignalRegistry": "Register of recent signals",
            "SignalsHeaderRegistryDate": "Date",
            "SignalsHeaderRegistryTicker": "Ticker",
            "SignalsHeaderRegistryAction": "Action",
            "SignalsHeaderRegistryVolume": "Volume",
            "SignalsHeaderRegistryPrice": "Price",
            "SignalsHeaderRegistryTakeStop": "Tk/St",
            "SignalsSignalAction": "action",
            "SignalsSignalVolume": "conventional volume",
            "SignalsSignalVolumeDescription": "The share of funds allocated to one company",
            "SignalsSignalPrice": "price",
            "RecommendationLabelBuy": "Buy",
            "RecommendationLabelSell": "Sell",
            "StateOfTradeLabelNeedOpenSeries": "Open the position",
            "StateOfTradeLabelNeedAddEnterInSeries": "Increase the position",
            "StateOfTradeLabelNeedAddExitInSeries": "Reduce the position",
            "StateOfTradeLabelNeedCloseSeries": "Close the position",
            "MainTitle": "Advisors",
            "MainTitleButtonOn": "Start",
            "MainTitleButtonOff": "Stop",
            "MainTableTitle": "Settings",
            "MainChoosingCountry": "Choosing a stock exchange country",
            "MainChoosingCountryPlaceholder": "Exchange country",
            "MainTipChoosingCountry": "You need to select a country!",
            "MainTipWaitDownloading": "Wait for the data to load!",
            "MainTipClickStart": "Click the start button to launch the Expert Advisor!",
            "SimulatedTransactionTitle": "Transaction Simulator",
            "CountryExchangeLabelRu": "Russia",
            "CountryExchangeLabelUS": "America",
            "GetDataColorIndicatorCharts": "Lagging chart loading indicator",
            "GetDataColorIndicatorQuotes": "The latest quotes loading indicator",
            "GetDataRatingIsExpired": "Ratings need to be updated",
            "GetDataRatingDateOfExpFUND": "Expiration date of the fundamental rating",
            "GetDataRatingDateOfExpTECH": "Expiration date of the technical rating",
            "GetDataRatingDateOfExpMEMB": "Expiration date of the rating of predictive users",
            "GetDataTipWaitDownloading": "Wait for the data to load!",
            "AdvisorsColorIndicatorAnalytics": "Analytical data loading indicator",
            "AdvisorsTableTitle": "Working with trading strategies",
            "AdvisorsSubmittedApplicationsTitle": "List of submitted orders",
            "AdvisorsTradingRecommendationsTitle": "Trading recommendations",
            "AdvisorsSwitchTracking": "Tracking",
            "AdvisorsSwitchAllNotifications": "Notifications",
            "SignalsToCustomers": "Signals to subscribers",
            "FreeSignal": "Free Signal",
            "AdvisorsToClosePosition": "To close a position",
            "AdvisorsToOpenPosition": "To open a position",
            "AdvisorsToIncreasePosition": "To increase  a position",
            "AdvisorsOrderStrategy": "Strategy",
            "AdvisorsOrderAction": "action",
            "AdvisorsOrderTimeframe": "timeframe",
            "AdvisorsOrderDiversificationGroup": "diversification group",
            "AdvisorsOrderSpecificities": "specificities",
            "AdvisorsOrderVolume": "conventional volume",
            "AdvisorsOrderVolumeDescription": "The share of funds allocated to one company",
            "AdvisorsOrderPrice": "price",
            "AdvisorsOrderMakeDeal": "make a deal",
            "AdvisorsOrderCancelOrder": "cancel the order",
            "AdvisorsOrderSubmitOrder": "submit the order",
            "AdvisorsOrderViewAnalytics": "view analytics",
            "PopupAnalyticsTitle": "Analytics of the company",
            "PopupAnalyticsTabNews": "News",
            "PopupAnalyticsTabAnalytics": "Analytics",
            "PopupAnalyticsTabCharts": "Charts",
            "PopupAnalyticsTabLong": "Long-term",
            "PopupAnalyticsTabCandlesticks": "Candlesticks",
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en",

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
